import { combineReducers } from 'redux'

import scrollPositionsReducer from '../../common/store/scrollPositions/reducer'
import userReducer from './user/reducer'

const rootReducer = () =>
  combineReducers({
    scrollPositionsReducer,
    userReducer,
  })

export default rootReducer
